import React, { useState, useEffect } from "react";
import { Form, Input, Button, Row, Col, Card, Table, Tag, notification } from "antd";
import {useLocation} from 'react-router-dom'
import styled from "styled-components";
import axios from 'axios'

const {TextArea} = Input

const Detail = () => {
    const token = localStorage.getItem("token")
    const loc = useLocation()
    const [description, setdesc] = useState("")
    const [oriData, setoridata] = useState({})
    const [loading, setLoading] = useState(false)

    const getData = async (id) => {
        let fetch = await axios.get('https://api.rajarental.co.id/api/v1.0/admin/how-to-order/' + id, {headers: {
          Authorization: token
        }})

        if(fetch) {
            let data = fetch.data.response
          setdesc(data.description)
          setoridata(data)
        }
      }

      useEffect(() => {
        if(loc.search && loc.search !== "") {
            getData(loc.search.split("?")[1].split("=")[1])
        }
      }, [])

      const submitForm = async () => {
          try {
              setLoading(true)
              
              if(loc.search && loc.search !== "") {
                  let id = loc.search.split("?")[1].split("=")[1]
                  let body = {}
                  let state = {
                      description
                  }
                  for(let key in oriData) {
                      if(oriData[key] != state[key]) {
                          body[key] = state[key]
                      }
                  }
                  if(description !== ""                
                  ) {
                      let update = await axios.put('https://api.rajarental.co.id/api/v1.0/admin/how-to-order/' + id, 
                          body,{headers: {
                        Authorization: token
                    }})

                    if(update) {
                        setLoading(false)
                        notification["success"]({
                            message: "Success Edit",
                        });
                        window.location.href = "/dashboard/how-to-order"
                    }
                  } else {
                    setLoading(false)
                    notification["warning"]({
                        message: "Deskripsi wajib diisi",
                        description:
                          "Please try again",
                      });
                  }
                  
              } else {
                  if(description !== "") {
                    let create = await axios.post('https://api.rajarental.co.id/api/v1.0/admin/how-to-order/', {
                        description
                    },{headers: {
                        Authorization: token
                    }})

                    if(create) {
                        setLoading(false)
                        notification["success"]({
                            message: "Success Add",
                        });
                        window.location.href = "/dashboard/how-to-order"
                    }
                  } else {
                    setLoading(false)
                    notification["warning"]({
                        message: "Deskripsi wajib diisi",
                        description:
                          "Please try again",
                      });
                  }
                
              }
          } catch (error) {

            console.log(error)
            setLoading(false)
            notification["warning"]({
                message: "Error",
                description:
                  "Please try again",
              });
          }
      }

    

    

    // console.log(username)

    return (
        <React.Fragment>
            <Card size="small" style={{padding: "20px 30px"}}>
                <Row justify="space-between">
                    <Col span={11}>
                        <p style={{marginBottom: 5}}>Deskripsi</p>
                        <TextArea rows={4} value={description} onChange={(e) => setdesc(e.target.value)}/>
                    </Col>
 
                    <Col span={24}>
                        <Button style={{float: 'right', marginTop: 25}} type="primary" loading={loading} onClick={submitForm}>Submit</Button>
                    </Col>
                    
                </Row>
            </Card>
        </React.Fragment>
    )
}

export default Detail